
import mapboxgl from 'mapbox-gl'

export default {
  props: {
    hotel: {
      type: Object,
      required: true,
    },
    toHotel: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      map: {},
      marker: null,
    }
  },
  head() {
    return {
      link: [
        {
          rel: 'stylesheet',
          href: 'https://api.mapbox.com/mapbox-gl-js/v2.4.1/mapbox-gl.css',
        },
      ],
    }
  },
  watch: {
    colorMode(value) {
      this.map.setStyle(
        value === 'dark'
          ? 'mapbox://styles/mapbox/dark-v10'
          : 'mapbox://styles/mapbox/streets-v11',
      )
    },
    toHotel(value) {
      this.setMarker(value)
    },
  },
  mounted() {
    mapboxgl.accessToken = this.$config.mapboxglAccessToken

    if (!['loaded', 'deferred'].includes(mapboxgl.getRTLTextPluginStatus())) {
      mapboxgl.setRTLTextPlugin(
        'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js',
        null,
        true,
      )
    }

    this.mapInit()
  },
  methods: {
    mapInit() {
      mapboxgl.accessToken = this.$config.mapboxglAccessToken
      this.map = new mapboxgl.Map({
        container: 'mapNearby',
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [this.hotel._geoloc.lng, this.hotel._geoloc.lat],
        zoom: 12,
        attributionControl: false,
      })
      new mapboxgl.Marker()
        .setLngLat([this.hotel._geoloc.lng, this.hotel._geoloc.lat])
        .addTo(this.map)
        .setPopup(
          new mapboxgl.Popup({
            closeOnClick: false,
            closeButton: false,
          }).setHTML('<h3>' + this.hotel.title + '</h3>'),
        )
        .togglePopup()
    },
    setMarker(item) {
      if (!this.marker) {
        this.marker = new mapboxgl.Marker()
          .setLngLat([item.geometry.location.lng, item.geometry.location.lat])
          .addTo(this.map)
      } else {
        this.marker.setLngLat([
          item.geometry.location.lng,
          item.geometry.location.lat,
        ])
      }
      this.marker
        .setPopup(
          new mapboxgl.Popup({
            closeOnClick: false,
            closeButton: false,
          }).setHTML('<h3>' + item.name + '</h3>'),
        )
        .togglePopup()

      this.map.fitBounds(
        [
          [item.geometry.location.lng, item.geometry.location.lat],
          [this.hotel._geoloc.lng, this.hotel._geoloc.lat],
        ],
        {
          padding: 20,
        },
      )
    },
  },
}
